<template lang="pug">
  article
    .bg-white.min-h-screen
      transition-group(:name="!entering ? 'pagefade' : 'none'", v-on:after-enter="$emit('afterEnter')")
        projects-by-gallery(v-if="view === 'gallery' && projects.length", key="gallery")
        projects-by-map(v-if="view === 'map'", key="map", :projects="projects")
        projects-by-text(v-if="view === 'archive'", key="archive", :prjs="projects")
</template>

<script>
import ProjectsByGallery from '@/components/ProjectsByGallery'
import ProjectsByMap from '@/components/ProjectsByMap'
import ProjectsByText from '@/components/ProjectsByText'
import { mapState } from 'vuex'

// Gallery (was Image) and Archive (was Text): old links keep working (build brief A4)
const VIEWS = { gallery: 'gallery', image: 'gallery', map: 'map', archive: 'archive', text: 'archive' }

export default {
  name: 'Projects',
  metaInfo: {
    title: 'Projects',
    meta: [
      { vmid: 'description', name: 'description', content: 'Explore murals and public artworks by Guido van Helten - browse the gallery, map or archive of projects.' },
      { vmid: 'og:title', property: 'og:title', content: 'Projects — Guido van Helten' },
      { vmid: 'og:description', property: 'og:description', content: 'Explore murals and public artworks by Guido van Helten - browse the gallery, map or archive of projects.' }
    ]
  },
  props: ['entering'],
  computed: {
    ...mapState(['projects']),
    view () {
      return VIEWS[this.$route.query.view] || 'gallery'
    }
  },
  watch: {
    entering (enter) {
      // jump to top after entering if skipped scrollBehavior
      if (!enter && this.$route.query.s === 0) {
        this.$router.replace({ query: {} })
        this.$nextTick(() => window.scroll(0, 0))
      }
    }
  },
  created () {
    this.$Progress.start()
    this.$store.dispatch('getProjects').then(() => this.$Progress.finish())
  },
  components: { ProjectsByGallery, ProjectsByMap, ProjectsByText }
}
</script>

<style>
</style>
